import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPrefix, selectWidth } from "../../utility/Redux/profile";
import GeniustextInput from "../../utility/component/mastertext";
import { toProperCase } from "../../utility/component/format";
import { PartyColumns } from "./columns";
import { setAlertWithTitle } from "../../utility/Redux/modal";
import { getAccountByMobile } from "../../utility/constant";
import { selectToken } from "../../utility/Redux/security";

const BasicInformation = ({
  partyName,
  missingId,
  setPartyName,
  gstNo,
  statesList,
  accountNo,
  citysList,
  setMissingId,
  setGstNo,
  panNo,
  setHelpStatus,
  setPanNo,
  mobileRef,
  phoneNo,
  setPhoneNo,
  mobile,
  setMobile,
  email,
  setEmail,
  website,
  setWebsite,
  creditAllow,
  creditPeriod,
  setCreditAllow,
  setCreditPeriod,
  setTabScreen,
  setPartyMasterhelpStatus,
  partyRefs,
  otherData,
  setotherData,
  taxRateRef,
}) => {
  const windowWidth = useSelector(selectWidth);
  const dispatch = useDispatch();
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  return (
    <>
      <div
        id={"Party Details"}
        className="grid md:grid-cols-[200px,1fr] ll:grid-cols-[400px,1fr]  border-b pb-2 p-3 "
      >
        <div>
          <div className="font-semibold text-[16px] text-black  w-fit ">
            Party Details
          </div>
          <div className="text-[12px] text-gray-600  w-fit ">
            Edit party details
          </div>
        </div>
        <div className=" justify-center  grid grid-cols-1   l:grid-cols-[350px,1fr,1fr] gap-2">
          <GeniustextInput
            title={"Party Name"}
            grid={true}
            search={() => {
              setPartyMasterhelpStatus(true);
            }}
            id={"partyName"}
            type={"text"}
            value={partyName}
            onChange={(e) => {
              setPartyName(e.target.value);
              const partyName = e.target.value;

              const match = partyName.match(/(\d+(\.\d+)?)%/);
              const percent = match ? parseFloat(match[1]) : null;
              if (percent) {
                setotherData((p) => {
                  return {
                    ...p,
                    TAX_RATE: percent,
                  };
                });
              }
            }}
          />
          {/* <GeniustextInput
            title={"Under Group"}
            grid={true}
            search={() => {
              setHelpStatus(true);
            }}
            id={"underGroup"}
            type={"text"}
            value={otherData.UNDER_GROUP}
            readOnly={true}
          /> */}
          <GeniustextInput
            title={"Opening Balance"}
            type={"number"}
            grid={true}
            value={otherData.OPENING_BALANCE}
            id={"GST"}
            onChange={(e) => {
              setotherData((o) => {
                return {
                  ...o,
                  OPENING_BALANCE: e.target.value,
                };
              });
            }}
          />

          <GeniustextInput
            title={"Bal. Type"}
            option={[
              {
                name: "Cr",
                value: "Cr",
              },
              {
                name: "Dr",
                value: "Dr",
              },
            ]}
            grid={true}
            value={otherData.OPENING_BALANCE_TYPE}
            id={"GST"}
            onChange={(e) => {
              setotherData((o) => {
                return {
                  ...o,
                  OPENING_BALANCE_TYPE: e.target.value,
                };
              });
            }}
          />

          <GeniustextInput
            title={"Category"}
            option={[
              {
                name: "GST",
                value: "GST",
              },
              {
                name: "VAT",
                value: "VAT",
              },
              {
                name: "Composition Schem",
                value: "Composition Scheme",
              },
              {
                name: "Unregistered Dealer",
                value: "Unregistered Dealer",
              },
            ]}
            grid={true}
            value={otherData.TAX_CATEGORY}
            id={"GST"}
            onChange={(e) => {
              setotherData((o) => {
                return {
                  ...o,
                  TAX_CATEGORY: e.target.value,
                };
              });
            }}
          />
          <GeniustextInput
            title={"GST Number"}
            type={"text"}
            grid={true}
            value={gstNo}
            id={"GST"}
            onChange={(e) => {
              setGstNo(e.target.value.toUpperCase());
              const panRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
              const match = e.target.value.match(panRegex);
              if (match) {
                setPanNo(match[0]);
              }
            }}
          />
          <GeniustextInput
            title={"PAN Number"}
            grid={true}
            type={"text"}
            value={panNo}
            // onChange={(e) => {
            //   setPanNo(e.target.value);
            // }}
          />
          <GeniustextInput
            title={"TDS Rate (%)"}
            grid={true}
            type={"number"}
            value={otherData.TDS_RATE}
            onChange={(e) => {
              setotherData((o) => {
                return {
                  ...o,
                  TDS_RATE: e.target.value,
                };
              });
            }}
          />
          <GeniustextInput
            title={"Interest Rate (%)"}
            grid={true}
            type={"number"}
            value={otherData.INTEREST_RATE}
            onChange={(e) => {
              setotherData((o) => {
                return {
                  ...o,
                  INTEREST_RATE: e.target.value,
                };
              });
            }}
          />
          <GeniustextInput
            title={"Tax Rate (%)"}
            grid={true}
            type={"number"}
            value={otherData.TAX_RATE}
            refrance={taxRateRef}
            onChange={(e) => {
              setotherData((o) => {
                return {
                  ...o,
                  TAX_RATE: e.target.value,
                };
              });
            }}
          />
          <GeniustextInput
            title={"Remarks"}
            grid={true}
            textArea={true}
            value={otherData.REMARKS}
            onChange={(e) => {
              setotherData((o) => {
                return {
                  ...o,
                  REMARKS: e.target.value,
                };
              });
            }}
          />
        </div>
      </div>

      <div
        id={"Basic Info"}
        className="grid md:grid-cols-[200px,1fr] ll:grid-cols-[400px,1fr]  border-b pb-2 p-3 "
      >
        <div>
          <div className="font-semibold text-[16px] text-black  w-fit ">
            Contact Details
          </div>
          <div className="text-[12px] text-gray-600  w-fit ">
            Edit party details
          </div>
        </div>
        <div className=" justify-center  grid grid-cols-1 md:grid-cols-3 gap-2">
          <GeniustextInput
            title={"Phone"}
            type={"text"}
            grid={true}
            value={phoneNo}
            onChange={(e) => {
              setPhoneNo(e.target.value);
            }}
          />
          <GeniustextInput
            title={"Mobile"}
            id={"mobile"}
            type={"number"}
            grid={true}
            error={"mobile"}
            value={mobile}
            onChange={async (e) => {
              setMobile(e.target.value);
            }}
            onBlur={async (e) => {
              if (e.target.value) {
                const isSameMobile = await getAccountByMobile(
                  prefix,
                  e.target.value,
                  token,
                  dispatch
                );
                if (!isSameMobile[0]) {
                } else {
                  if (isSameMobile[0].ACCOUNT_NO !== accountNo) {
                    setMobile("");

                    dispatch(
                      setAlertWithTitle({
                        title: "Alert",
                        msg: "Already registered party with same mobile",
                      })
                    );
                  }
                }
              }
            }}
            refrance={mobileRef}
          />
          <GeniustextInput
            title={"Email"}
            grid={true}
            type={"text"}
            error={"email"}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <GeniustextInput
            title={"Website"}
            type={"text"}
            grid={true}
            value={website}
            onChange={(e) => {
              setWebsite(e.target.value);
            }}
          />
        </div>
      </div>

      {/* <div
        id={"Basic Info"}
        className="grid md:grid-cols-[200px,1fr] ll:grid-cols-[400px,1fr]  border-b pb-2 p-3 "
      >
        <div>
          <div className="font-semibold text-[16px] text-black  w-fit ">
            Credits Details
          </div>
          <div className="text-[12px] text-gray-600  w-fit ">
            Edit credits details
          </div>
        </div>
        <div className=" justify-center grid grid-cols-1 md:grid-cols-4 gap-2">
          <GeniustextInput
            title={"Credit Limit Allow"}
            type={"number"}
            grid={true}
            value={creditAllow}
            onChange={(e) => {
              setCreditAllow(e.target.value);
            }}
          />
          <GeniustextInput
            title={"Credit Limit Period"}
            type={"number"}
            grid={true}
            value={creditPeriod}
            onChange={(e) => {
              setCreditPeriod(e.target.value);
            }}
          />
        </div>
      </div> */}
    </>
  );
};

export default BasicInformation;
